const names = new Intl.DisplayNames(['en'], { type: 'region' });

/** "RS" → "Serbia". A code the browser does not know stays as it came. */
export function regionName(code) {
  try {
    return names.of(code) ?? code;
  } catch {
    return code;
  }
}
